import { useMutation, useQueryClient } from 'react-query';
import { toast } from 'sonner';

import { APIBaseChronos } from '../hosts';
import { QueryEntity } from '../types';
import useGetFetchConfig, { FetchMethod } from '../useGetFetchConfig';
import { FactComment } from '@/types';

interface UseUpdateCommentParams {
  content: string;
}

export const useUpdateComment = (matterId: string, commentId: string, subsetId?: string) => {
  const { getFetchConfig } = useGetFetchConfig();
  const queryClient = useQueryClient();

  return useMutation<FactComment, Error, UseUpdateCommentParams>(
    async ({ content }: UseUpdateCommentParams) => {
      const fetchConfig = getFetchConfig({
        method: FetchMethod.PATCH,
        data: {
          content,
        },
      });

      const response = await fetch(`${APIBaseChronos}/api/matter/${matterId}/comments/${commentId}`, fetchConfig);

      if (!response.ok) {
        throw new Error('Failed to update comment');
      }

      return response.json();
    },
    {
      onSuccess: () => {
        if (subsetId) {
          queryClient.invalidateQueries({ queryKey: [QueryEntity.SubsetFacts, { subsetId }] });
        }
        queryClient.invalidateQueries({ queryKey: [QueryEntity.ChronologyFacts] });
        toast.success('Comment updated successfully');
      },
      onError: (error) => {
        console.error('Error updating comment:', error);
        toast.error('Failed to update comment. Please try again.');
      },
    },
  );
};
